import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck } from "lucide-react";
import AuthShell from "@/pages/auth/AuthShell";
import { Field, SubmitButton, FormError } from "@/components/forms/Field";
import { api, errMsg } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Reset your password" subtitle="Enter your account email and we will send you a secure reset link."
      footer={<Link to="/login" className="font-semibold text-ds-plum link-underline" data-testid="forgot-back-to-login">Back to sign in</Link>}>
      {sent ? (
        <div className="card-surface p-8 text-center" data-testid="forgot-password-sent">
          <MailCheck className="h-10 w-10 text-ds-plum mx-auto" />
          <p className="mt-4 font-display text-xl font-bold">Check your inbox</p>
          <p className="mt-1 text-sm text-ds-inksoft">If an account exists for {email}, a reset link is on its way. It is valid for 1 hour.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-password-form">
          <Field id="email" label="Email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} testId="forgot-email-input" />
          <FormError message={error} />
          <SubmitButton busy={busy} testId="forgot-submit-button">Send reset link</SubmitButton>
        </form>
      )}
    </AuthShell>
  );
}
